import { render, staticRenderFns } from "./RecordForm.vue?vue&type=template&id=5f78e81e&scoped=true"
import script from "./RecordForm.vue?vue&type=script&lang=js"
export * from "./RecordForm.vue?vue&type=script&lang=js"
import style0 from "./RecordForm.vue?vue&type=style&index=0&id=5f78e81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f78e81e",
  null
  
)

export default component.exports